<template>
<div class="bottom-bar">
  <a v-for="bottom in bottomList" :key="bottom.id" :href='"#/" + bottom.name.toLocaleLowerCase()'>
    <img :src="bottom.icon" alt="" v-if="activeMenu !== bottom.name.toLocaleLowerCase()">
    <img :src="bottom.aicon" alt="" v-else>
    <span>{{ bottom.name }}</span>
  </a>

</div>
</template>

<script>
export default {
  name: 'bottomBar',
  data () {
    return {
      bottomList: [
        {
          name: this.$t('i18n.Website.Home'),
          icon: require('@/assets/img/bottom-bar/home.png'),
          aicon: require('@/assets/img/bottom-bar/home-active.png')
        },
        {
          name: this.$t('i18n.Website.Services'),
          icon: require('@/assets/img/bottom-bar/sercice.png'),
          aicon: require('@/assets/img/bottom-bar/sercice-active.png')
        },
        {
          name: this.$t('i18n.Website.Blog'),
          icon: require('@/assets/img/bottom-bar/blog.png'),
          aicon: require('@/assets/img/bottom-bar/blog-active.png')
        },
        {
          name: this.$t('i18n.Website.FAQ'),
          icon: require('@/assets/img/bottom-bar/faq.png'),
          aicon: require('@/assets/img/bottom-bar/faq-active.png')
        },
        {
          name: this.$t('i18n.Website.About'),
          icon: require('@/assets/img/bottom-bar/about.png'),
          aicon: require('@/assets/img/bottom-bar/about-active.png')
        }
      ]
    }
  },
  computed: {
    activeMenu () {
      return this.$route.path.slice(1)
    }
  }
}
</script>

<style lang="scss" scoped>

.bottom-bar {
  width: 100%;
  height: 50px;
  background: #fafafa;
  box-shadow: 0px -0.5px rgba(200,199,204,0.5);
  position: fixed;
  bottom: 0px;

  display: flex;
  justify-content: space-around;
  align-items: center;

  a {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  a:hover {
    text-decoration: none;
  }

  span {
    display: block;
    color: #666666;
    font-size: 13px;
    height: 16px;
  }

  img {
    width: 22px;
    height: 22px;

  }
}

@media (min-width: 500px) {
  .bottom-bar {
    display: none;
  }
}

.active {
  font-weight: bold;
  border-bottom: .1rem solid #4E98FF;
}
</style>



// WEBPACK FOOTER //
// src/Layout/components/bottom-bar.vue